<p8-layout-settings-page>

  <p8-layout-settings-header
    [titlePath]="[title]"
    [iconRacine]="iconTitle">
  </p8-layout-settings-header>

  <mat-card class="bel-view">
    <div class="header">
      Informations du BEL
    </div>
    <mat-card-content>
      <div class="line">
        <div class="label">
          Libellé :
        </div>
        <div class="content">
          {{Bel?.label}}
        </div>
      </div>
      <div class="line">
        <div class="label">
          Statut :
        </div>
        <div class="content">
          {{belSvc.displayState(Bel)}}
        </div>
      </div>
      <div class="line">
        <div class="label">
          Observations du service :
        </div>
        <div class="content">
          <p [innerHtml]="Bel?.observations | newline "></p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="bel-inf-comp">
    <div class="header">Informations complémentaires</div>
    <mat-card-content *ngIf="Bel?.id">
      <app-informations-complementaires [Bel]="Bel"></app-informations-complementaires>
    </mat-card-content>
  </mat-card>

  <mat-card class="bel-bordereaux">
    <div class="header">Bordereaux</div>
    <mat-card-content>
      <div class="line">
        <div class="label">
          Bordereau d'élimination :
        </div>
        <div class="actions">
          <app-download-files
            [type]="'BEL signé'"
            [file]="Bel.bordereau_elimination_object"
            [tooltip]="'Edition du bordereau d\'élimination signé par les archives départementales'">
          </app-download-files>
        </div>
      </div>
      <div class="line">
        <div class="label">
          Bordereau de destruction :
        </div>
        <div class="actions">
          <app-download-files
            [type]="'Bordereau de destruction'"
            [file]="Bel.bordereau_destruction_object"
            [tooltip]="'Edition du bordereau de destruction'">
          </app-download-files>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="bel-documents">
    <div class="header">Documents du BEL</div>
    <mat-card-content>
      <div *ngIf="Bel.id > 0" fxLayout="row" fxLayoutGap="2px">
        <app-documents [Bel]="Bel" [visualize]="true"></app-documents>
      </div>
    </mat-card-content>
  </mat-card>

  <p8-layout-settings-footer [flexLayoutAlign]="'end'">
    <button mat-raised-button type="button"
          (click)="goList()"
          matTooltip="Retour à la liste des BEL"
          data-cy="btn-bel-edit-back">
      Retour à votre liste
    </button>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
